import { render, staticRenderFns } from "./SedangMenunggu.vue?vue&type=template&id=aef3e796&scoped=true&"
import script from "./SedangMenunggu.vue?vue&type=script&lang=js&"
export * from "./SedangMenunggu.vue?vue&type=script&lang=js&"
import style0 from "./SedangMenunggu.vue?vue&type=style&index=0&id=aef3e796&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef3e796",
  null
  
)

export default component.exports